import React, { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '../../firebase/firebase'
import { t } from '../../components/i18n/i18n'
import back from '../../assets/images/elements/timeHeader.jpg'
import '../../assets/css/pages.css'

const DAY_ORDER = { mon: 0, tue: 1, wed: 2, thu: 3, fri: 4, sat: 5, sun: 6 }

const FALLBACK_DAYS = [
  {
    key: 'tue', labelUa: 'Вівторок', labelEn: 'Tuesday', accent: '#f07a28', icon: '🙏',
    events: [
      { time: '10:00', descUa: 'Молитовне зібрання для сестер',                              descEn: 'Prayer gathering for sisters' },
      { time: '17:00', descUa: 'Мами в молитві',                                              descEn: 'Mothers in prayer' },
      { time: '19:00', descUa: 'Вивчення Біблії для братів; Окремо - спілкування сестер',    descEn: 'Bible study for brothers; Separately - sisters communication' },
    ],
  },
  {
    key: 'wed', labelUa: 'Середа', labelEn: 'Wednesday', accent: '#d4a800', icon: '📖',
    events: [
      { time: '19:00', descUa: 'Вивчення Святого Письма для молоді', descEn: 'Bible study for youth' },
    ],
  },
  {
    key: 'fri', labelUa: 'П\'ятниця', labelEn: 'Friday', accent: '#3aaa6e', icon: '✝',
    events: [
      { time: '10:00', descUa: 'Загальноцерковне Молитовне служіння', descEn: 'General church prayer worship' },
    ],
  },
  {
    key: 'sat', labelUa: 'Субота', labelEn: 'Saturday', accent: '#3a8fd9', icon: '👥',
    events: [
      { time: '12:00', descUa: 'Аванна',               descEn: 'Avanna' },
      { time: '15:00', descUa: 'Підліткове служіння',   descEn: 'Youth worshipping' },
      { time: '18:00', descUa: 'Спілкування молоді',    descEn: 'Youth communication' },
    ],
  },
  {
    key: 'sun', labelUa: 'Неділя', labelEn: 'Sunday', accent: '#7c5cbf', icon: '⛪',
    events: [
      { time: '10:00', descUa: 'Загальноцерковне Ранкове зібрання', descEn: 'General Morning Worship' },
      { time: '18:00', descUa: 'Загальноцерковне Вечірнє зібрання', descEn: 'General Evening Worship' },
    ],
  },
]

const DayCard = ({ day, full = false, lang = 'ua' }) => (
  <div className='day-card'>
    <div className='day-card__head' style={{ background: day.accent }}>
      <span className='day-card__icon'>{day.icon}</span>
      <span className='day-card__name'>{lang === 'en' && day.labelEn ? day.labelEn : day.labelUa}</span>
    </div>
    <div className={`day-card__body${full ? ' day-card__body--full' : ''}`}>
      {day.events.map((ev, i) => (
        <div key={i} className='event-row'>
          <span className='time-pill' style={{ background: day.accent }}>{ev.time}</span>
          <span className='event-desc'>{lang === 'en' && ev.descEn ? ev.descEn : ev.descUa}</span>
        </div>
      ))}
    </div>
  </div>
)

export const Schedule = () => {
  const lang = localStorage.getItem('userLanguage') === 'en' ? 'en' : 'ua'
  const [days, setDays] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let rawDays = []
    let rawEvents = []
    let daysLoaded = false
    let eventsLoaded = false

    const merge = () => {
      if (!daysLoaded || !eventsLoaded) return
      const merged = rawDays
        .map(day => ({
          ...day,
          events: rawEvents
            .filter(e => e.dayKey === day.key)
            .sort((a, b) => a.order - b.order),
        }))
        .sort((a, b) => (DAY_ORDER[a.key] ?? 99) - (DAY_ORDER[b.key] ?? 99))
      setDays(merged.length > 0 ? merged : [])
      setLoading(false)
    }

    const unsubDays = onSnapshot(
      query(collection(db, 'scheduleDays'), orderBy('order')),
      snap => { rawDays = snap.docs.map(d => ({ id: d.id, ...d.data() })); daysLoaded = true; merge() }
    )
    const unsubEvents = onSnapshot(
      query(collection(db, 'scheduleEvents'), orderBy('order')),
      snap => { rawEvents = snap.docs.map(d => ({ id: d.id, ...d.data() })); eventsLoaded = true; merge() }
    )
    return () => { unsubDays(); unsubEvents() }
  }, [])

  const displayDays = (!loading && days.length > 0) ? days : FALLBACK_DAYS
  const gridDays = displayDays.slice(0, -1)
  const lastDay  = displayDays[displayDays.length - 1]

  return (
    <>
      <div className='page-hero'>
        <img src={back} alt='' />
        <div className='page-hero__overlay' />
        <h1 className='page-hero__title'>{t('scheduleHeader')}</h1>
      </div>

      <div className='sched-page'>
        <div className='sched-grid'>
          {gridDays.map(day => <DayCard key={day.key} day={day} lang={lang} />)}
        </div>
        {lastDay && <DayCard day={lastDay} full lang={lang} />}
      </div>
    </>
  )
}
